var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: this.styleClass,
      on: {
        click: function($event) {
          return _vm.getFile()
        }
      }
    },
    [
      _vm._t(
        "body",
        [
          !_vm.isDownloading
            ? _c("div", [_vm._v(" " + _vm._s(_vm.label || _vm.name) + " ")])
            : _vm._e(),
          _vm.isDownloading
            ? _c("b-spinner", {
                staticClass: "mr-1",
                attrs: { variant: "primary" }
              })
            : _vm._e()
        ],
        { downloading: this.isDownloading }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }